import { render, staticRenderFns } from "./OverviewHeader.vue?vue&type=template&id=66a7bd18&scoped=true"
import script from "./OverviewHeader.vue?vue&type=script&lang=ts"
export * from "./OverviewHeader.vue?vue&type=script&lang=ts"
import style0 from "./OverviewHeader.vue?vue&type=style&index=0&id=66a7bd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a7bd18",
  null
  
)

export default component.exports